function useKeyHandler(handlerByKeys) {
  return e => {
    const keyHandler = handlerByKeys[e.keyCode];
    keyHandler && keyHandler(e);
  };
}

export { useKeyHandler };
